<!--
 * @Description:
 * @Author: rqcheng
 * @Date: 2023-03-30 08:57:42
 * @LastEditTime: 2023-04-03 10:58:03
 * @LastEditors: rqcheng
-->
<template>
  <div id="app">
    <router-view v-if="show" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "App",
  data() {
    return {
      show: true
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.setCurrentRegion();
    },
    reload() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    ...mapActions(["setCurrentRegion"])
  }
};
</script>

<style lang="less">
#app {
  font-family: "SourceRegular";
  text-align: center;
  color: #111;
}
</style>



// WEBPACK FOOTER //
// src/App.vue